import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puzfo = () => {
    return (
        <div>
                <NavLink to='/category/Puzzels/Puzzel5'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel3'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Pay an employee using a gold rod of 7 units ?</h1>
    
    
    <div class="text">
        <p>An employee works for an employer for 7 days. The employer has a gold rod of 7 units. How does the employer
            pay to the employee, so that the number of employee’s rod units increases by one at the end of each day? The
            employer can make at most 2 cuts in the rod.&nbsp;</p>
        <p>(Hint- after the end of the day employee’s can’t spend any part of rod)</p>
        <p><strong>Solution:</strong>&nbsp;<br/>
        <div className='containers'>
            The employer can pay for seven days by making 2 cuts in a way that he has
            3 rods of size 1, 2 and 4.&nbsp;<br/>
            <strong>1st Day:</strong> Employer gives 1 unit
            cut.&nbsp;<br/>
            <strong>2nd day:</strong> Takes back 1 unit cut from employee given on the first day and gives
            2 unit cut.&nbsp;<br/>
            <strong>3rd Day:</strong> Gives 1 unit and then the employer is left with 4 unit rod
            lengths.&nbsp;<br/>
            <strong>4th Day:</strong> Takes back cuts of 1 and 2 units. Gives the cut of 4
            units.&nbsp;<br/>
            <strong>5th Day:</strong> Gives cut of 1 unit to the employee.&nbsp;<br/>
            <strong>6th
                Day:</strong> Takes back cut of 1 unit and gives a cut of 2 units.&nbsp;<br/>
                <strong>7th Day:</strong>
            Gives cut of 1 unit to the employee.&nbsp;</div></p>
        
    </div>
</article>
        </div>
    )
}

export default Puzfo
